import React, { Component, Fragment } from 'react'
import Header from '../Header/Header';
// import Footer from '../Footer/Footer';
import Sidebar from './Sidebar';

class MainApp extends Component {
    render() {
        return (
            <Fragment>
                <Header />
                <div className="container-fluid">
                    <div className="row">

                        <Sidebar />

                        {this.props.children}

                    </div>
                </div>
            </Fragment>
        );
    }
}

export default MainApp